module.exports = __webpack_public_path__ + "static/media/reservation.2f363e71.svg";